import React, { useState } from "react";
import { Formik } from "formik";
import { connect } from "react-redux";
import clsx from "clsx";
import * as auth from "../../store/ducks/auth.duck";
import { login } from "../../crud/auth.crud";
import * as utils from "../../../_metronic/utils/utils";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { toAbsoluteUrl } from "../../../_metronic";
import CustomInput from "../../components/CustomInput";
import FakeInputAutofill from "../../components/FakeInputAutofill";
import { useSnackbar } from "notistack";

function Login(props) {
	const [loading, setLoading] = useState(false);
	const [loadingButtonStyle, setLoadingButtonStyle] = useState({ paddingRight: "2.5rem" });

	const { enqueueSnackbar, closeSnackbar } = useSnackbar();

	const enableLoading = () => {
		setLoading(true);
		setLoadingButtonStyle({ paddingRight: "3.5rem" });
	};

	const disableLoading = () => {
		setLoading(false);
		setLoadingButtonStyle({ paddingRight: "2.5rem" });
	};

	return (
		<div class="authContainerContainer login">
			<div className="d-flex flex-column justify-content-center align-items-center gap-40">
				<img alt="Logo" src={toAbsoluteUrl("/images/logo-white.png")} style={{ width: 124, height: "auto" }} />

				<div className="d-flex flex-column gap-12 text-center">
					<span className="color-white tt-24 semibold">
						Bem-vindo(a) ao OliverAI
					</span>

					<span className="color-dark-6 tt-16 w-100">
						Informe suas credenciais para acessar o sistema.
					</span>
				</div>

				<Formik
					initialValues={{ email: "", password: "" }}
					validate={(values) => {
						const errors = {};

						if (!values.email) {
							errors.email = "O email é uma informação obrigatória.";
						} else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
							errors.email = "Você precisa informar um email válido.";
						}

						if (!values.password) {
							errors.password = "A senha é uma informação obrigatória.";
						}

						return errors;
					}}
					onSubmit={(values, { setSubmitting }) => {
						enableLoading();

						login(values.email, values.password)
							.then((res) => {
								disableLoading();

								utils.setStorage("authToken", res.data.token, null);
								props.login(res.data);
								closeSnackbar();
							})
							.catch(() => {
								disableLoading();

								setSubmitting(false);

								enqueueSnackbar("Usuário ou senha incorretos.", {
									variant: "error",
									anchorOrigin: { horizontal: "center", vertical: "bottom" },
									autoHideDuration: 5000,
								});
							});
					}}
				>
					{({ errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => {
						return (
							<form noValidate autoComplete="off" className="kt-form mt-0" onSubmit={handleSubmit}>
								<FakeInputAutofill />

								<div className="form-group">
									<CustomInput
										placeholder="Informe seu email"
										label="E-mail"
										name="email"
										type="email"
										handleBlur={handleBlur}
										handleChange={handleChange}
										errors={errors}
										touched={touched}
										disabled={loading}
									/>
								</div>

								<div className="form-group" style={{ marginBottom: 16 }}>
									<CustomInput
										placeholder="Informe sua senha"
										label="Senha"
										name="password"
										handleBlur={handleBlur}
										handleChange={handleChange}
										errors={errors}
										touched={touched}
										disabled={loading}
									/>
								</div>

								<div className="kt-login__actions">
									<Row className="gap-40">
										<Col sm={12}>
											<p className="esqueceuSenha">
												<Link to="/esqueceu-senha">
													<span className="color-dark-6 tt-16 medium">Esqueceu sua senha?</span>
												</Link>
											</p>
										</Col>

										<Col sm={12}>
											<button
												id="kt_login_signin_submit"
												type="submit"
												disabled={isSubmitting}
												className={`loginBtn btn ${clsx({
													"kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": loading,
												})}`}
												style={loadingButtonStyle}
											>
												Acessar
											</button>
										</Col>

										<Col sm={12}>
											<p className="linkSignin w-100 text-center">
												<span className="color-dark-6 tt-16">Não possui conta? <Link className="medium" to="/signin">Cadastre-se aqui</Link></span>
											</p>
										</Col>
									</Row>
								</div>
							</form>
						);
					}}
				</Formik>
			</div>


		</div>
	);
}

export default connect(null, auth.actions)(Login);
